import {MSG_ERRO_PADRAO} from '../util/constantes'

import {AMBIENTE} from '../util/params'

import {TIPO_AMB_DEV} from '../util/constantes'

import {Alert}  from 'react-native';

import * as texto from '../util/texto'

import * as numeros from '../util/numeros'

import {EDR_TIPO_RESIDENCIAL, EDR_TIPO_COMERCIAL, EDR_TIPO_COBRANCA,
PEDIDO_SITUACAO_ATIVO, PEDIDO_SITUACAO_CANCELADO, PEDIDO_SITUACAO_CONCLUIDO, TELA_PRINCIPAL} from '../util/constantes'

import Alerta from '../componentes/Alerta'




export async function getToken(){
    return null;
}


export function converteEmJson(dados){

    try {
		return temConteudo(dados)?JSON.parse(dados):null;
	}
	catch (e) {

		print("util - converteEmJson - exception - "+e);
	
		return null;
	} 
}


export function alertaErroGenerico() {
	
	Alerta("Erro", MSG_ERRO_PADRAO);
}


export function print(msg) {
	
	if(AMBIENTE == TIPO_AMB_DEV)
		console.log(msg);
}


export function temConteudo(dados){

	if (dados==null)
		return false;
	
	if((typeof dados === 'object' || dados instanceof Object) && !Array.isArray(dados))
		return true;
	
	if(Array.isArray(dados))
		return dados.length>0;
	
	return texto.isNotBlanck(dados);
	
}


export function quandoNull(valor, usarQuandoNulll){

    return valor===null || valor == undefined?usarQuandoNulll:valor;
}


export function primeiroOuNada(lista){

	if (lista==null)
		return null;

	if(!Array.isArray(lista))
		return lista;
	
	return lista.length>0?lista[0]:null;
	
}


export function getExtensao(nome){

    var ext = nome.split('/').pop();

    ext = ext.indexOf('.') < 1 ? '' : ext.split('.').pop();

    return ext
}


export function getMime(extensaoDoArquivo) {

    if(extensaoDoArquivo===null)
		return "";

    extensaoDoArquivo =   extensaoDoArquivo.toLowerCase();

	if(extensaoDoArquivo=="pdf")
		return "application/pdf";
		
	if(extensaoDoArquivo=="jpeg" || 
		extensaoDoArquivo=="jpg" ||
			extensaoDoArquivo=="jpe")
		return "image/jpeg";
        
	if(extensaoDoArquivo=="png")
		return "image/png";
				
	if(extensaoDoArquivo=="txt" || 
		extensaoDoArquivo=="text")
		return "text/plain";	    
					
	if(extensaoDoArquivo=="xml" ||
		extensaoDoArquivo=="xsl")
		return "text/xml";	
		
	if(extensaoDoArquivo=="docx")
	    return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
				  
	if(extensaoDoArquivo=="xlsx")
		return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
		
	if(extensaoDoArquivo=="doc")
		return "application/msword";
		
	if(extensaoDoArquivo=="xls")
		return "application/excel";
				
	if(extensaoDoArquivo=="ppt")
		return "application/powerpoint";	
		
	if(extensaoDoArquivo=="zip")
		return "application/zip";
		
	if(extensaoDoArquivo=="bmp")
		return "image/bmp";
		
	if(extensaoDoArquivo=="gif")
		return "image/gif";
						    			
	return "";
}


export async function deletarArquivo(RNFS, uri) {

    if(await RNFS.exists(uri))
        await RNFS.unlink(uri);
}


export function formataNome(nomeCompleto){
	
	if(texto.isBlanck(nomeCompleto))
		return null;
	
    const nomes = nomeCompleto.split(' ');

	 const primeiroNome = nomes[0];

	if(nomes.length ==1)
		return primeiroNome.charAt(0).toUpperCase() + primeiroNome.slice(1);
	
    return primeiroNome.charAt(0).toUpperCase() + primeiroNome.slice(1)+' '+(nomes[nomes.length - 1]).charAt(0).toUpperCase()+'.';
}


export function substring(valor, comprimento){

	if(texto.isBlanck(valor))
		return null;
	
	if(valor.length <=comprimento)
		return 	valor;	
	
	return valor.substring(0, comprimento)+"...";
}


export function temPropriedade(objeto, prop){

    return Object.prototype.hasOwnProperty.call(objeto, prop);
}


export function getDescricaoTipoEndereco(tipo){
		
	if(tipo == EDR_TIPO_RESIDENCIAL)
		return "Residencial";
		
	if(tipo == EDR_TIPO_COMERCIAL)
		return "Comercial";
		
	if(tipo == EDR_TIPO_COBRANCA)
		return "Cobrança";
		
	return null;
}


export function getDescricaoSituacaoPedido(situacao){
		
	if(situacao == PEDIDO_SITUACAO_ATIVO)
		return "Ativo";
		
	if(situacao == PEDIDO_SITUACAO_CANCELADO)
		return "Cancelado";
		
	if(situacao == PEDIDO_SITUACAO_CONCLUIDO)
		return "Concluído";
		
	return null;
}


export function criarPares(array) {
  
	if(array==null)
		return null;
  
	const resultado = [];

	  for (let i = 0; i < array.length; i += 2) {
		
		const par = [array[i], array[i + 1] || null];
		
		resultado.push(par);
	  }

	return resultado;
}


export function outrasInfosItem(item){
		
		let dados = ""
		
		if(texto.isNotBlanck(item.marca))
			dados += item.marca+" "
		
		if(texto.isNotBlanck(item.modelo))
			dados += item.modelo+" "
		
		if(texto.isNotBlanck(item.cor))
			dados += item.cor+" "
		
		if(texto.isNotBlanck(item.tamanho))
			dados += item.tamanho
		
		return dados;
}


export function ordenar(lista, chave, ordenacao_ascendente=true, como_numero=true) {
	
	if(chave==null)
		return lista;
	
	return lista.sort((a, b) => {
		
		let aux1 = a[chave];
		let aux2 = b[chave];
		
		//print(aux1+" "+aux2)
		
		if(aux1 == null && aux2 == null)
			return 0;
		
		if(aux1 == null)
			return ordenacao_ascendente?1:-1;
		
		if(aux2 == null)
			return ordenacao_ascendente?-1:1;
		
		if(como_numero){
			aux1 = numeros.getFloat(aux1);
			aux2 = numeros.getFloat(aux2);
		}

		print(aux1+" "+aux2)

		if(ordenacao_ascendente)
			return aux1 > aux2?1:(aux1 < aux2?-1:0);	
		else
			return aux1 < aux2?1:(aux1 > aux2?-1:0);
	
	});
}


export function setVoltar(valor){

	print("setVoltar para "+valor);

	localStorage.setItem('voltar', valor==null?'':valor);
}


export function processaVoltar(){

	let valor = localStorage.getItem('voltar')

	setVoltar(null);

	print("voltando para |"+valor+"|");

	return temConteudo(valor)? valor:TELA_PRINCIPAL;
}